export enum NodeViewType {
  Image = 'image',
  MultipleChoiceItem = 'multiple-choice-item',
  Snippet = 'snippet',
  Variable = 'variable',
  Equation = 'equation'
}
